import { render, staticRenderFns } from "./RiskOrgnManage_Detail.vue?vue&type=template&id=3559bcab&scoped=true&"
import script from "./RiskOrgnManage_Detail.vue?vue&type=script&lang=js&"
export * from "./RiskOrgnManage_Detail.vue?vue&type=script&lang=js&"
import style0 from "./RiskOrgnManage_Detail.vue?vue&type=style&index=0&id=3559bcab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3559bcab",
  null
  
)

export default component.exports